import React from "react";
import { motion } from "framer-motion";

export const LoadingSpinner = () => {
  return (
    <div className="w-screen h-screen flex flex-col justify-center items-center bg-surface-50 dark:bg-dark-surface-50">
      <motion.div
        className="relative w-16 h-16"
        animate={{ rotate: 360 }}
        transition={{
          duration: 1.5,
          repeat: Infinity,
          ease: "linear",
        }}
      >
        {/* Outer ring */}
        <motion.div
          className="absolute inset-0 border-4 border-transparent border-t-primary border-r-primary-light rounded-full dark:border-t-dark-primary dark:border-r-dark-primary-light"
          initial={{ opacity: 0.7, scale: 1 }}
          animate={{ 
            opacity: [0.7, 0.9, 0.7],
            scale: [1, 1.05, 1]
          }}
          transition={{ 
            duration: 1.5, 
            repeat: Infinity,
            ease: "easeInOut" 
          }}
        />
        
        {/* Inner ring */}
        <motion.div
          className="absolute inset-2 border-4 border-transparent border-t-primary-light border-l-primary rounded-full dark:border-t-dark-primary-light dark:border-l-dark-primary"
          initial={{ opacity: 0.5 }}
          animate={{ 
            opacity: [0.5, 0.8, 0.5],
            rotate: 180
          }}
          transition={{ 
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut",
            repeatType: "reverse"
          }}
        />
        
        {/* Center circle */}
        <motion.div
          className="absolute inset-4 bg-primary-light/20 dark:bg-dark-primary-light/20 rounded-full flex items-center justify-center"
          initial={{ opacity: 0.8 }}
          animate={{ 
            opacity: [0.8, 1, 0.8],
            scale: [1, 1.1, 1]
          }}
          transition={{ 
            duration: 1.2, 
            repeat: Infinity,
            ease: "easeInOut" 
          }}
        >
          <motion.div 
            className="w-4 h-4 bg-primary dark:bg-dark-primary rounded-full"
            animate={{ 
              scale: [0.8, 1.2, 0.8]
            }}
            transition={{ 
              duration: 1, 
              repeat: Infinity,
              ease: "easeInOut" 
            }}
          />
        </motion.div>
      </motion.div>
      
      <motion.div
        className="mt-4 font-semibold text-primary-dark dark:text-dark-primary-dark"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5, duration: 0.5 }}
      >
        Loading...
      </motion.div>
    </div>
  );
};

export default LoadingSpinner;